import {
  TESTIMONIAL_LIST_LOADING,
  GET_TESTIMONIAL_LIST,
  GET_TESTIMONIAL_LIST_ERROR,
  GET_TESTIMONIAL_BY_ID_LOADING,
  GET_TESTIMONIAL_BY_ID_SUCCESS,
  GET_TESTIMONIAL_BY_ID_ERROR,
  DELETEING_TESTIMONIAL,
  DELETE_TESTIMONIAL,
  DELETE_TESTIMONIAL_ERROR,
  DELETED_TESTIMONIAL_LIST_LOADING,
  GET_DELETED_TESTIMONIAL_LIST,
  GET_DELETED_TESTIMONIAL_LIST_ERROR,
  PERMA_DELETEING_TESTIMONIAL,
  PERMA_DELETE_TESTIMONIAL,
  PERMA_DELETE_TESTIMONIAL_ERROR,
  RESTORE_TESTIMONIAL_LIST_LOADING,
  RESTORE_TESTIMONIAL_LIST,
  RESTORE_TESTIMONIAL_LIST_ERROR
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: TESTIMONIAL_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/testimonial/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_TESTIMONIAL_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_TESTIMONIAL_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_TESTIMONIAL_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/testimonial/active/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_TESTIMONIAL_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_TESTIMONIAL_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_TESTIMONIAL_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/testimonial/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_TESTIMONIAL_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_TESTIMONIAL_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_TESTIMONIAL,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/testimonial/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_TESTIMONIAL,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_TESTIMONIAL_ERROR,
        payload: error.response,
      })
      message.success(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_TESTIMONIAL,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/testimonial/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_TESTIMONIAL,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_TESTIMONIAL_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_TESTIMONIAL_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/testimonial/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_TESTIMONIAL_LIST,
        payload: response,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_TESTIMONIAL_LIST_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};